var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { class: _vm.classes, attrs: { for: _vm.id } }, [
    _c("input", {
      class: _vm.mdsNS("form__radio-button-input"),
      attrs: {
        id: _vm.id,
        type: "radio",
        name: _vm.name,
        disabled: _vm.disabled
      },
      domProps: { value: _vm.value, checked: _vm.checked },
      on: { click: _vm.click }
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        class: [
          _vm.mdsNS("form__radio-button-visible-wrap"),
          _vm.namespace("visible-wrap")
        ]
      },
      [
        _c("span", { class: _vm.mdsNS("form__radio-button-visual") }),
        _vm._v(" "),
        _c("span", {
          class: [_vm.mdsNS("form__radio-button-text"), _vm.namespace("text")],
          domProps: { innerHTML: _vm._s(_vm.label) }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }